import fetch from 'isomorphic-unfetch';
import {IS_TEST, TEST_HOST} from 'common/constants';

const fetcher = async <JSON = any>(url: RequestInfo, options?: RequestInit): Promise<JSON> => {
  const res = await fetch(IS_TEST ? `${TEST_HOST}${url}` : url, options);
  return res.json();
};

export default fetcher;
